import React from "react";
import { Phone } from "lucide-react";
import { SITE } from "../lib/site";

export default function MobileCallBar() {
  return (
    <a
      href={SITE.phoneHref}
      data-testid="mobile-call-bar"
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-black text-white flex items-center justify-center gap-3 py-4 border-t border-white/10"
    >
      <Phone size={18} strokeWidth={1.5} />
      <span className="text-sm tracking-wide font-medium">
        Nous appeler — {SITE.phone}
      </span>
    </a>
  );
}
